module.exports = __webpack_public_path__ + "media/images/media/images/pic/teachers/anna-sielawko-e1ee14e39d388b7fa210ac90206e4ed2.png";